// removed by extract-text-webpack-plugin
module.exports = {"container":"src-ui----CodeSample-module---container---3WXKZ","horizontal":"src-ui----CodeSample-module---horizontal---304Uh","vertical":"src-ui----CodeSample-module---vertical---1ovwY"};


//////////////////
// WEBPACK FOOTER
// ./src/ui/CodeSample.module.scss
// module id = 561
// module chunks = 168707334958949